// Angular
import { Injectable, inject } from '@angular/core';
// RxJs
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from '@environment';
// Service
import { CommonService } from './common.service';
// Constants
import { APP_CONSTANT } from '@constants';
export const WS_ENDPOINT = environment.wsEndpoint;

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  readonly cs = inject(CommonService);


  // Private
  private socket$: WebSocketSubject<any>;

  /**
   * Open web socket connection
   * @returns WebSocketSubject
   */
  connect(): WebSocketSubject<any> {
    if (!this.socket$ || this.socket$.closed) {
      this.socket$ = this.getWebSocket();
    }
    return this.socket$;
  }

  /**
   * Close web socket connection
   */
  close() {
    this.socket$.complete();
  }

  /**
   * Return a custom WebSocket subject
   * @returns WebSocketSubject
   */
  private getWebSocket(): WebSocketSubject<any> {
    const jwt = this.cs.getFromLocalStorage(APP_CONSTANT.JWT_TOKEN_KEY);
    const webSocketUrl = `${WS_ENDPOINT}token?${jwt}`;
    return webSocket({
      url: webSocketUrl
    });
  }

}
